import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components';
import { teamImage } from '../data/mediaData';

export const AboutPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50">
      {/*/!* Hero Section *!/*/}
      {/*<section className="bg-gradient-to-br from-primary-600 to-primary-700 text-white py-20">*/}
      {/*  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">*/}
      {/*    <h1 className="text-4xl md:text-5xl font-bold mb-6">About The Cleaning Crew</h1>*/}
      {/*    <p className="text-xl text-primary-50 max-w-3xl mx-auto">*/}
      {/*      Your trusted partner for professional cleaning services, dedicated to making your space spotless and healthy.*/}
      {/*    </p>*/}
      {/*  </div>*/}
      {/*</section>*/}

      {/* Our Story Section */}
      <section className="py-16 bg-teal-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Our Story</h2>
              <p className="text-gray-600 mb-4">
                Founded with a passion for cleanliness and customer satisfaction, The Cleaning Crew has been serving our community with excellence and dedication. We believe that a clean space is essential for a healthy and productive life.
              </p>
              <p className="text-gray-600 mb-4">
                What started as a small team with big dreams has grown into a trusted name in professional cleaning services. Our commitment to quality, reliability, and customer care remains at the heart of everything we do.
              </p>
              <p className="text-gray-600 mb-6">
                We take pride in our work and treat every space as if it were our own, ensuring the highest standards of cleanliness and hygiene.
              </p>
              <Button 
                onClick={() => navigate('/gallery')}
                className="inline-flex items-center gap-2"
              >
                See Our Work
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </Button>
            </div>
            <div className="bg-gray-200 rounded-lg overflow-hidden aspect-video">
              <img
                src={teamImage}
                alt="Our Team"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLImageElement).src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="800" height="450"%3E%3Crect fill="%23e5e7eb" width="800" height="450"/%3E%3Ctext fill="%239ca3af" font-family="sans-serif" font-size="32" dy="10.5" font-weight="bold" x="50%25" y="50%25" text-anchor="middle"%3EOur Team%3C/text%3E%3C/svg%3E';
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* How We Work Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">How We Work</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4">
                <img src="https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/icons/orderbook.png" alt="Book Your Service" className="w-full h-full object-contain" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">1. Book Your Service</h3>
              <p className="text-gray-600">
                Submit an inquiry through our website or contact us directly. Tell us about your cleaning needs and preferred schedule.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4">
                <img src="https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/icons/weconfirm.png" alt="We Confirm & Plan" className="w-full h-full object-contain" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">2. We Confirm & Plan</h3>
              <p className="text-gray-600">
                Our team reviews your request, confirms the details, and creates a customized cleaning plan tailored to your needs.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4">
                <img src="https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/icons/clean-house.png" alt="We Clean" className="w-full h-full object-contain" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">3. We Clean</h3>
              <p className="text-gray-600">
                Our professional team arrives on time with all necessary equipment and delivers exceptional cleaning results.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/*/!* Our Values Section *!/*/}
      {/*<section className="py-16 bg-white">*/}
      {/*  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">*/}
      {/*    <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Our Values</h2>*/}
      {/*    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">*/}
      {/*      <div className="text-center">*/}
      {/*        <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mb-4 mx-auto">*/}
      {/*          <span className="text-4xl">🎯</span>*/}
      {/*        </div>*/}
      {/*        <h3 className="text-lg font-bold text-gray-800 mb-2">Quality</h3>*/}
      {/*        <p className="text-gray-600 text-sm">*/}
      {/*          We never compromise on the quality of our service and always strive for excellence.*/}
      {/*        </p>*/}
      {/*      </div>*/}
      {/*      <div className="text-center">*/}
      {/*        <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mb-4 mx-auto">*/}
      {/*          <span className="text-4xl">🔒</span>*/}
      {/*        </div>*/}
      {/*        <h3 className="text-lg font-bold text-gray-800 mb-2">Trust</h3>*/}
      {/*        <p className="text-gray-600 text-sm">*/}
      {/*          Your trust is our priority. We ensure security and confidentiality in every service.*/}
      {/*        </p>*/}
      {/*      </div>*/}
      {/*      <div className="text-center">*/}
      {/*        <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mb-4 mx-auto">*/}
      {/*          <span className="text-4xl">💚</span>*/}
      {/*        </div>*/}
      {/*        <h3 className="text-lg font-bold text-gray-800 mb-2">Eco-Friendly</h3>*/}
      {/*        <p className="text-gray-600 text-sm">*/}
      {/*          We use environmentally safe products that are effective yet gentle on the planet.*/}
      {/*        </p>*/}
      {/*      </div>*/}
      {/*      <div className="text-center">*/}
      {/*        <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mb-4 mx-auto">*/}
      {/*          <span className="text-4xl">⚡</span>*/}
      {/*        </div>*/}
      {/*        <h3 className="text-lg font-bold text-gray-800 mb-2">Reliability</h3>*/}
      {/*        <p className="text-gray-600 text-sm">*/}
      {/*          Count on us to be punctual, professional, and consistent in every visit.*/}
      {/*        </p>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</section>*/}

    </div>
  );
};
